import { Injectable } from '@angular/core';
import { jwt_decode } from "jwt-decode";

@Injectable()
export class WpTokenService {

  private TOKEN_SESSION_KEY = "wp_token";

  constructor() {
  }

  storeToken(token) {
    sessionStorage.setItem(this.TOKEN_SESSION_KEY, token);
  }

  destroyToken(){
    sessionStorage.removeItem(this.TOKEN_SESSION_KEY);
  }

  getToken(){
    return sessionStorage.getItem(this.TOKEN_SESSION_KEY);
  }

  isTokenExpired() {
    let tokenString = sessionStorage.getItem(this.TOKEN_SESSION_KEY);
    if (!tokenString || tokenString == 'undefined') {
      return true;
    }
    let decoded = jwt_decode(tokenString);
    if ( decoded.exp === undefined || decoded.exp < Date.now()) {
      this.destroyToken();
      return true;
    }

    return false;
  }

  isLoginToken() {
    let tokenString = sessionStorage.getItem(this.TOKEN_SESSION_KEY);
    if (!tokenString || tokenString == 'undefined') {
      return false;
    }
    let decoded = jwt_decode(tokenString);
    if ( decoded.exp === undefined || decoded.exp < Date.now() || !(decoded.login)) {
      this.destroyToken();
      return false;
    }

    return true;
  }
}
